// extracted by mini-css-extract-plugin
export default {"root":"SimpleLoader_root__3HvxR","circle":"SimpleLoader_circle__2bSgt","rotateLoader":"SimpleLoader_rotateLoader__9RtW+","cirle":"SimpleLoader_cirle__nwjE4"};